import React from 'react';
import styled from '@emotion/styled';
import { Popper } from '@bucketplace/design-system/bds';

import { loadCommand, newCommand, saveCommand } from '../../commands/save';
import { useEditor } from '../../hooks/useEditor';
import { HeaderButton } from './HeaderButton';
import { HeaderTogglePreview } from './TogglePreview';

export interface HeaderProps {
  className?: string;
}

export function Header(props: HeaderProps): React.ReactElement {
  const { className } = props;
  const { dispatch } = useEditor();

  const HeaderMenus = [
    { label: '새로 만들기', handler: newCommand },
    { label: '열기', handler: loadCommand },
    { label: '저장', handler: saveCommand },
  ];

  return (
    <HeaderContainer className={className}>
      <HeaderSide>
        <StyledPopper
          placement="bottom-start"
          renderButton={({ isOpen, onClick }) => {
            return (
              <HeaderButton
                isActive={isOpen}
                onClick={onClick}
              >
                파일
              </HeaderButton>
            );
          }}
        >
          { HeaderMenus.map((menu) => (
            <DropDownMenuItemButton onClick={() => dispatch(menu.handler())}>
              { menu.label }
            </DropDownMenuItemButton>
          )) }
        </StyledPopper>
      </HeaderSide>
      <HeaderSide>
        <HeaderTogglePreview />
      </HeaderSide>
    </HeaderContainer>
  );
}

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 19px;
  border-bottom: 1px solid ${({ theme }) => theme.base.neutral600};
  background-color: ${({ theme }) => theme.base.neutral600};
  color: ${({ theme }) => theme.base.neutral0};
`;

const HeaderSide = styled.div``;

const StyledPopper = styled(Popper)`
  width: 160px;
`;

const DropDownMenuItemButton = styled.button`
  display: block;
  padding: 5px 8px;
  text-align: left;
  font-size: 12px;
  line-height: 21px;
  background-color: ${({ theme }) => theme.base.neutral0};
  border-radius: 8px;
  transition: 0.1s background-color;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.base.neutral300};
  }
`;
